module.exports = __webpack_public_path__ + "static/media/brands_LITTLE.cd5f8a23.svg";